// extracted by mini-css-extract-plugin
export var mainWrapper = "VCNavBar-module--mainWrapper--oh0hV";